angular.module('impactx.statusicon', [])

    .controller('StatusIconsCtrl', ['$scope', 'demandStatusIcon', 'requestStatusIcon', 'orderStatusIcon', 'deliveryStatusIcon', 'billStatusIcon', '$sce', function ($scope, demandStatusIcon, requestStatusIcon, orderStatusIcon, deliveryStatusIcon, billStatusIcon, $sce)
    {
        $scope.getDemandStatusIcon = demandStatusIcon;
        $scope.getRequestStatusIcon = requestStatusIcon;
        $scope.getOrderStatusIcon = orderStatusIcon;
        $scope.getDeliveryStatusIcon = deliveryStatusIcon;
        $scope.getBillStatusIcon = billStatusIcon;

        $scope.$sce = $sce;
    }])
    
    .factory("demandStatusIcon", function ()
    {
        var demandStatusIcons = ["mdi-icon-grey", "mdi-icon-yellow", "mdi-icon-green", "mdi-icon-yellow", "mdi-icon-red",
            "mdi-icon-red", "mdi-icon-red", "", "", "", "", "", "", ""];
        var baseClasses = "mdi mdi-24px mdi-shopping ";
        return function (statusValue)
        {
            return (statusValue === undefined || demandStatusIcons[statusValue] === undefined || demandStatusIcons[statusValue] === '') ? baseClasses + demandStatusIcons[0] : baseClasses + demandStatusIcons[statusValue];
        }
    })
    
    .factory("requestStatusIcon", function ()
    {
        var checked = "mdi mdi-24px mdi-icon-green mdi-check-circle";
        var circle = "mdi mdi-24px mdi-icon-yellow mdi-checkbox-blank-circle";
        var close = "mdi mdi-24px mdi-icon-red mdi-close-circle";
        var requestStatusIcons = ["mdi mdi-24px mdi-icon-grey mdi-checkbox-blank-circle", circle, checked, circle, close, circle, close, "", "", "", "", "", "", "", close, checked, close, close, checked];
        return function (statusValue)
        {
            return (statusValue === undefined || requestStatusIcons[statusValue] === undefined || requestStatusIcons[statusValue] === '') ? requestStatusIcons[0] : requestStatusIcons[statusValue];
        }
    })

    .factory("orderStatusIcon", function ()
    {
        var orderStatusIcons = ["mdi-icon-grey", "mdi-icon-grey", "mdi-icon-green", "mdi-icon-yellow", "mdi-icon-red",
            "mdi-icon-yellow", "mdi-icon-red", "", "", "", "", "", "", "", "mdi-icon-green", "", "", "", "", "", "mdi-icon-green"];
        var baseClasses = "mdi mdi-24px mdi-email ";
        return function (statusValue)
        {
            return (statusValue === undefined || orderStatusIcons[statusValue] === undefined || orderStatusIcons[statusValue] === '') ? baseClasses + orderStatusIcons[0] : baseClasses + orderStatusIcons[statusValue];
        }
    })

    .factory("deliveryStatusIcon", function ()
    {
        var deliveryStatusIcons = ["mdi-icon-grey", "mdi-icon-yellow", "mdi-icon-green", "", "", "", "", "", "", "mdi-icon-green",
            "mdi-icon-red", "mdi-icon-green", "mdi-icon-green", "mdi-icon-yellow", "mdi-icon-grey", "", "", "", "",
            "", "", "mdi-icon-green"];
        var baseClasses = "mdi mdi-24px mdi-truck-delivery ";
        return function (statusValue)
        {
            return (statusValue === undefined || deliveryStatusIcons[statusValue] === undefined || deliveryStatusIcons[statusValue] === '') ? baseClasses + deliveryStatusIcons[0] : baseClasses + deliveryStatusIcons[statusValue];
        }
    })

    .factory("billStatusIcon", function ()
    {
        var billStatusIcons = ["mdi-icon-grey", "", "", "mdi-icon-yellow"];
        var baseClasses = "mdi mdi-24px mdi-file-document ";
        return function (statusValue)
        {
            return (statusValue === undefined || billStatusIcons[statusValue] === undefined || billStatusIcons[statusValue] === '') ? baseClasses + billStatusIcons[0] : baseClasses + billStatusIcons[statusValue];
        }
    });